import { Component, Input, inject } from '@angular/core';
import { ControlContainer, ReactiveFormsModule, FormControl } from '@angular/forms';
import { NgForOf } from '@angular/common';
import { ClrCommonFormsModule, ClrSelectModule } from '@clr/angular';
import { TranslocoDirective } from '@jsverse/transloco';

export const COUNTRY_CODES = [
  'AT','AU','BE','CA','CN','CZ','DE','DK','ES','FR',
  'GB','HR','HU','IN','IT','JP','KR','LU','NL','NO',
  'PL','PT','RO','RU','SE','CH','SI','SK','TR','UA','US'
] as const;

@Component({
  selector: 'app-country-select',
  standalone: true,
  imports: [ReactiveFormsModule, NgForOf, ClrCommonFormsModule, ClrSelectModule, TranslocoDirective],
  viewProviders: [
    { provide: ControlContainer, useFactory: () => inject(ControlContainer, { skipSelf: true }) }
  ],
  template: `
    <clr-select-container *transloco="let t; prefix: 'countries'">
      <label [class]="labelClass">{{ label }}</label>
      <select [class]="selectClass" clrSelect [formControlName]="controlName">
        <option value="">Bitte wählen...</option>
        <option *ngFor="let code of countryCodes" [value]="code">{{ t(code) }}</option>
      </select>
    </clr-select-container>
  `
})
export class CountrySelectComponent {
  @Input({ required: true }) controlName!: string;
  @Input() label: string = 'Land';
  @Input() labelClass: string = '';
  @Input() selectClass: string = '';

  readonly countryCodes = COUNTRY_CODES;
}
